const siblingsEndpoint = (url, sectionIds) => {
  const endpoint = new URL(url, window.location.origin);
  endpoint.searchParams.set('sections', sectionIds.join(','));
  return endpoint.pathname + endpoint.search;
};

const sectionIdOf = (wrapper) => wrapper?.id?.replace(/^shopify-section-/, '') || null;

const handleFromUrl = (url) => url?.split('/products/')[1]?.split(/[?#]/)[0] || null;

class ProductPageSiblings extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.addEventListener('click', this.onClick);
    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('popstate', this.onPopState);
  }

  onClick = (event) => {
    if (window.Shopify && window.Shopify.designMode) return;

    const link = event.target.closest('[data-sibling-link]');
    if (!link || !this.contains(link)) return;

    event.preventDefault();
    if (link.classList.contains('selected')) return;

    const url = link.getAttribute('href');
    const handle = link.getAttribute('data-sibling-handle') || handleFromUrl(url);
    if (url && handle) this.switchTo(handle, url, true);
  };

  onPopState = () => {
    const url = window.location.pathname + window.location.search;
    const handle = handleFromUrl(url);
    if (handle) this.switchTo(handle, url, false);
    else window.location.reload();
  };

  reviewsSection() {
    const sections = [...document.querySelectorAll('.shopify-section')];
    return sections.find(
      (s) => s !== this.section && s.querySelector('.jdgm-widget, .jdgm-rev-widg, [class*="jdgm-"]')
    );
  }

  swapSectionInner(wrapper, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('.shopify-section') || doc.body;
    incoming.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.remove('scroll-trigger'));
    wrapper.innerHTML = incoming.innerHTML;
  }

  async switchTo(handle, url, push) {
    if (!this.section) {
      window.location.href = url;
      return;
    }

    const reviews = this.reviewsSection();
    const targets = [{ wrapper: this.section, id: sectionIdOf(this.section) }];
    if (reviews && reviews !== this.section) {
      targets.push({ wrapper: reviews, id: sectionIdOf(reviews) });
    }

    const ids = targets.map((t) => t.id).filter(Boolean);
    if (ids.length === 0) {
      window.location.href = url;
      return;
    }

    const wrapper = this.section;
    wrapper.style.opacity = '0.5';
    wrapper.style.pointerEvents = 'none';

    try {
      const res = await fetch(siblingsEndpoint(url, ids));
      if (!res.ok) throw new Error('fetch failed');
      const data = await res.json();

      targets.forEach(({ wrapper: target, id }) => {
        if (data[id]) this.swapSectionInner(target, data[id]);
      });

      document.dispatchEvent(new CustomEvent('pdp:section-rerendered', { detail: { handle } }));

      const newTitle = this.section.querySelector('.product__title, h1');
      if (newTitle && newTitle.textContent.trim()) {
        document.title = document.title.replace(/^[^–|]*/, newTitle.textContent.trim() + ' ');
      }

      if (push) window.history.pushState({ productSiblingsSwap: true }, '', url);
    } catch (e) {
      window.location.href = url;
      return;
    } finally {
      wrapper.style.opacity = '';
      wrapper.style.pointerEvents = '';
    }
  }
}

if (!customElements.get('product-page-siblings')) {
  customElements.define('product-page-siblings', ProductPageSiblings);
}
